<template>
  <div class="course-container">
    <download-top></download-top>
    <pay-loading :payLoading="payLoading" @close="payLoading = false"></pay-loading>
    <sold-out v-if="course && !course.state"></sold-out>
		<div class="swiper">
			<img :src="picture">
		</div>
		<div class="content">
			<div class="header" v-if="course">
				<div class="header_title">
					{{course.title}}
				</div>
				<div class="header_desc">
					{{course.intro}}
				</div>
				<div class="header_price" v-if="course">
					{{course.totalChapter}}节 / <span class="red">¥</span> <span class="red big">{{course.priceAndroid}}</span> <span class="line-through" v-if="course.originalPrice">¥{{course.originalPrice}}</span>
					<span class="float_right">{{ studyCount | conversion }}人已学习</span>
				</div>
			</div>
			<div class="nav">
				<div @click="changeNav(0)" :class="{active: showFlag == 0}" v-track="{ name: 'course_change_Nav0' }">
					<span class="text">课程介绍</span>
					<span class="line"></span>
				</div>
				<div @click="changeNav(1)" :class="{active: showFlag == 1}" v-track="{ name: 'course_change_Nav1' }">
					<span class="text">章节目录</span>
					<span class="line"></span>
				</div>
			</div>
			<div v-if="showFlag == 0" class="courseInfo">
				<ul class="desc">
					<li v-for="(item,index) in content" :key='index'>
						<h3>{{item.title}}</h3>
						<div v-html="item.content"></div>
					</li>
				</ul>
			</div>
			<div v-else class="directory">
				<div v-for="(item,index) in chapterList" :key='index' class="contentbox">
					<h4>{{item.chapterTitle}}</h4>
					<ul>
						<li v-for="(v,k) in item.section" :key='k' class="flex">
							<img src="../../assets/course/play.png" class="play">
							<div class="right flex">
								<span>{{v.secTitle}}</span>
								<div class="right-icon">
									<p v-if="v.secState == 0 " class="try" @click="toDownload" v-track="{ name: 'course_download' }">免费试看</p>
									<img v-if="v.secState == 2 " src="../../assets/course/lock.png" class="lock">
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="footer">
			<div v-if="course && course.state == 1 && (course.isBuy != 0 || course.isCharge == 0)" class="free" @click="toDownload" v-track="{ name: 'course_download' }">进入学习</div>
			<div v-else class="buy-action">
				<div class="price">
					<div class="red">¥ <span class="big red">{{course.priceAndroid}}</span></div>
					<div class="header_desc">{{ studyCount | conversion }}人已学习</div>
				</div>
				<van-button v-if="course && course.state == 0" class="buy" slot="button" type="danger">已下架</van-button>
				<van-button
          v-else
          class="buy"
          slot="button"
          type="danger"
          v-track="{ name: 'course_buy', params: { courseGuid: $route.query.courseGuid } }"
          :loading="actionLoading"
          @click="buyCourse">
          立即报名
        </van-button>
			</div>
		</div>
  </div>
</template>

<script>
import DownloadTop from '@/components/DownloadTop'
import SoldOut from '@/components/SoldOut'
import Button from 'vant/lib/button'
import 'vant/lib/button/style'

import OrderMixins from '@/mixins/order' //订单相关公用方法

import { api_courseInfoDetails } from '@/api/course'
export default {
  name: 'course',
  components: {
    DownloadTop,
    SoldOut,
    [Button.name]: Button
  },
  mixins: [OrderMixins],
  filters: {
    conversion(value) {
      // 转换单位
      var k = 10000;
      var value = Number(value);
      if (value >= 1000000) {
        value = '100万+'
      } else if (value >= k) {
        value = Math.round((value / 10000) * 100) / 100;
        value = value.toFixed(2) + '万'
      }
      return value
    }
  },
  watch: {
    payLoading: {
      deep: true,
      handler(newVal) {
        // 若为false则说明订单状态请求完成，此时更新用户信息
        if (!newVal) this.getCourseData()
      }
    }
  },
  computed: {
    userToken: {
      get() {
        return this.$store.state.token
      }
    },
  },
  data() {
    return {
      showFlag: 0,
      picture: '',
      chapterList: [],
      course: '',
      content: [],
      studyCount: 0,
      courseGuid: '',
      actionLoading: false,
    }
  },
  created() {
    this.$track('start_course')
  },
  mounted() {
    this.courseGuid = this.$route.query.courseGuid
    if (this.courseGuid) this.getCourseData()
  },
  methods: {
    getCourseData() {
      api_courseInfoDetails({
        courseGuid: this.courseGuid
      }).then(res => {
        if (res.status === 200) {
          this.picture = res.data.pictureBig || res.data.picture;
          this.chapterList = res.data.chapterList;
          this.course = res.data;
          this.content = res.data.content;
          this.studyCount = res.data.studyCount ? Number(res.data.studyCount) : 0;
          this.$store.dispatch('share/initShareParams', {
            title: this.course.title,
            desc: this.course.intro,
            imgUrl: this.picture
          })
        }
      })
    },
    buyCourse() {
      if (this.userToken) {
        this.actionLoading = true
        this.$createOrder({
          source: 3,
          ordertype: 0,
          resources: JSON.stringify([{
            resourceId: this.courseGuid,
            number: 1
          }])
        }).finally(() => {
          this.actionLoading = false
        })
      } else {
        this.$router.push('/login')
      }
    },
    toDownload() {
      this.$router.push({
        path: '/download',
        query: {
          courseGuid: this.courseGuid
        }
      })
    },
    changeNav(e) {
      this.showFlag = e
    }
  }
}
</script>

<style lang="scss">
  .course-container {
    .swiper {
    	padding-top: 50px;
    }

    .swiper img {
    	width: 100%;
    	height: auto;
    }

    .header_title {
    	margin-top: 5px;
    	font-size: 19px;
    	line-height: 20px;
    	font-weight: 500;
    }

    .header_desc {
    	font-size: 14px;
    	line-height: 20px;
    	color: #959595;
    }

    .header_price {
    	font-size: 14px;
    	color: #959595;
    	line-height: 20px;
    	padding-bottom: 10px;
    	border-bottom: 1px solid #e0e0e0;
    	margin-bottom: 5px;
    }

    .red {
    	color: #ed5b68;
    }

    .big {
    	font-size: 20px;
    	font-weight: 500;
    }

    .line-through {
    	text-decoration: line-through;
    }

    .float_right {
    	float: right;
    }

    .content {
    	padding: 0 12px 110px;
    	background-color: #fff;
    }

    .nav {
    	width: 100%;
    	display: flex;
    	justify-content: center;
    	align-items: center;
    	font-size: 16px;
    	padding: 10px 0;
    }

    .nav div {
    	flex: 1;
    	text-align: center;
    }

    .nav div span {
    	display: block;
    	font-weight: bold;
    	color: #999;
    }

    .nav div.active span {
    	color: #333;
    }

    .nav div span.line {
    	width: 10%;
    	margin: 5px auto 0;
    	border-bottom: 1px solid #fff;
    }

    .nav div.active span.line {
    	border-bottom: 3px solid #e45c6a;
    }

    /* 课程介绍 */
    .courseInfo {}

    .courseInfo .title {
    	border-bottom: 1px solid #ccc;
    	padding: 10px 0;
    }

    .courseInfo .title h3 {
    	line-height: 25px;
    	padding: 5px 0;
    	font-size: 17px;
    }

    .courseInfo .title span {
    	font-size: 14px;
    	color: #999;
    	align-items: center;
    }
    .courseInfo .title span img {
    	width: 17px;
    	height: 17px;
    	margin-right: 5px;
    	margin-left: 2px;
    	position: relative;
    	top: 1px;
    }

    .courseInfo .desc li {
    	margin-top: 5px;
    }

    .courseInfo .desc li h3 {
    	height: 40px;
    	line-height: 40px;
    	font-size: 16px;
    }

    .courseInfo .desc li div {
    	font-size: 14px;
    	line-height: 1.5;
    }
    .courseInfo .desc li div img {
    	max-width: 100%;
    }
    /* 章节目录 */
    .directory .play {
    	width: 20px;
    	height: 20px;
    	margin-right: 10px;
    }

    .directory .lock {
    	width: 18px;
    	height: 18px;
    	margin-right: 10px;
    }
    .directory .contentbox {
    	margin-top: 15px;
    }

    .directory ul {
    	margin-top: 10px;
    }

    .directory li, .directory li .right {
    	align-items: center;
    }

    .directory li .right {
    	width: 0;
    	flex: 1;
    	padding: 10px 0;
    	border-bottom: 1px solid #e1e1e1;
    	justify-content: space-between;
    }
    .directory li .right span {
    	flex: 1;
    	white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .directory li .right .right-icon {
    	padding-left: 25px;
    }
    .directory li .right .right-icon .try {
    	height: 28px;
    	line-height: 28px;
    	font-size: 14px;
    	color: #fff;
    	background-color: #e75965;
    	padding: 0 10px;
    	border-radius: 28px;
    }
    /* 底部footer */
    .footer {
    	position: fixed;
    	left: 0;
    	bottom: 0;
    	width: 100%;
    }

    .free {
    	width: 100%;
    	height: 50px;
    	line-height:50px;
    	text-align: center;
    	background-color: #e75965;
    	color: #fff;
    	font-size: 15px;
    }

    .buy-action {
    	width: 100%;
    	height: 50px;
    	background-color: #fff;
    	font-size: 15px;
    	display: flex;
    	align-items: center;
    	flex-direction: row;
    }

    .price {
    	padding-left: 15px;
    	flex: 1;
    	height: 50px;
    	display: flex;
    	flex-direction: column;
    	justify-content: center;
    }

    .buy {
    	width: 125px;
    	line-height: 50px;
    	background-color: #f3636c;
    	text-align: center;
    	color: #fff;
    	height: 50px !important;
    }
  }
</style>
